'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reduxForm = require('redux-form');

var _reactBootstrap = require('react-bootstrap');

var _dateFunctions = require('../../helpers/dateFunctions');

var _dateFunctions2 = _interopRequireDefault(_dateFunctions);

var _LabelledInputComponent = require('../../components/input/LabelledInputComponent');

var _LabelledInputComponent2 = _interopRequireDefault(_LabelledInputComponent);

var _SelectComponent = require('../../components/input/SelectComponent');

var _SelectComponent2 = _interopRequireDefault(_SelectComponent);

var _SectionHeaderComponent = require('../../components/common/SectionHeaderComponent');

var _SectionHeaderComponent2 = _interopRequireDefault(_SectionHeaderComponent);

var _DatePickerComponent = require('../../components/input/DatePickerComponent');

var _DatePickerComponent2 = _interopRequireDefault(_DatePickerComponent);

var _TextInputComponent = require('../../components/input/TextInputComponent');

var _TextInputComponent2 = _interopRequireDefault(_TextInputComponent);

var _formConfiguration = require('../../transformers/common/formConfiguration');

var _formConfiguration2 = _interopRequireDefault(_formConfiguration);

var _translate = require('../../language/translate');

var _InitialValues = require('../common/InitialValues');

var _InitialValues2 = _interopRequireDefault(_InitialValues);

var _commonFunctions = require('../../helpers/commonFunctions');

var _dates = require('../../transformers/student-accident/dates');

var _dates2 = _interopRequireDefault(_dates);

var _Quote = require('../../validators/student-accident/Quote');

var _Quote2 = _interopRequireDefault(_Quote);

var _application = require('../../transformers/student-accident/application');

var _application2 = _interopRequireDefault(_application);

var _quote = require('../../transformers/student-accident/quote');

var _quote2 = _interopRequireDefault(_quote);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var fields = [].concat(_toConsumableArray((0, _commonFunctions.getBaseFields)()), _toConsumableArray((0, _commonFunctions.getApplicantDetailFields)()), ['application.additional_data.coverage_type', 'application.additional_data.eligibility', 'application.additional_data.school', 'applicant[].additional_data.school', 'application.additional_data.school_other', 'applicant[].additional_data.school_other']);

/**
 * Renders the part of the form which generates a live quote.
 * @extends {Component}
 */

var GetQuoteComponent = function (_React$Component) {
  _inherits(GetQuoteComponent, _React$Component);

  function GetQuoteComponent(props) {
    _classCallCheck(this, GetQuoteComponent);

    var _this = _possibleConstructorReturn(this, (GetQuoteComponent.__proto__ || Object.getPrototypeOf(GetQuoteComponent)).call(this, props));

    _this.onChangeHook = _this.onChangeHook.bind(_this);
    _this.getDefaultExpiryDate = _this.getDefaultExpiryDate.bind(_this);

    _this.state = {
      showSaveQuote: true,
      showErrors: false,
      formFilled: false,
      showNames: true
    };
    return _this;
  }

  _createClass(GetQuoteComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.formConfig = (0, _formConfiguration2.default)(this.props.formConfig)[0].fields;
      if (this.props.fields.application.additional_data.additional_applicants_number.value === '') {
        this.props.fields.application.additional_data.additional_applicants_number.onChange(_InitialValues2.default.additional_applicants_number);
      }
      if (this.props.fields.applicant.length === 0) {
        this.props.fields.applicant.addField();
      }
    }
  }, {
    key: 'onChangeHook',
    value: function onChangeHook() {
      (0, _commonFunctions.updateQuote)(this, _application2.default);
    }
  }, {
    key: 'getDefaultExpiryDate',
    value: function getDefaultExpiryDate() {
      var effDate = this.props.fields.application.effective_date.value;
      return effDate ? (0, _moment2.default)(effDate).add(364 + _dateFunctions2.default.getLeapYearDay(effDate, 364), 'days') : null;
    }
  }, {
    key: 'updateProp',
    value: function updateProp(propName, value) {
      this.props.dispatch((0, _reduxForm.change)('genericis', propName, value));
    }
  }, {
    key: 'disableExpiryDate',
    value: function disableExpiryDate() {
      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      (0, _quote2.default)(this);
      var dateRestrictions = (0, _dates2.default)(this.props.values);

      return _react2.default.createElement(
        _reactBootstrap.Form,
        { horizontal: true, onSubmit: this.props.handleSubmit },
        (0, _commonFunctions.showErrorDiv)(this),
        _react2.default.createElement(
          _SectionHeaderComponent2.default,
          null,
          this.formConfig.school_board_section_header.title
        ),
        _react2.default.createElement(_LabelledInputComponent2.default, {
          hasExpandableHint: true,
          expandableHintId: 'schoolBoardHint',
          expandableHintTitle: this.formConfig['additional_data.school_board'].label,
          expandableHintContent: this.formConfig['additional_data.school_board'].hint,
          inputId: 'schoolBoard',
          inputLabel: this.formConfig['additional_data.school_board'].title,
          inputComponent: _SelectComponent2.default,
          inputComponentField: this.props.fields.application.additional_data.school,
          inputComponentProps: {
            options: this.formConfig['additional_data.school_board'].options,
            onChangeHook: this.onChangeHook
          }
        }),
        this.props.fields.application.additional_data.school.value === 'other' && _react2.default.createElement(_LabelledInputComponent2.default, {
          inputId: 'schoolBoardOther',
          inputLabel: this.formConfig['additional_data.school_board_other'].title,
          inputComponent: _TextInputComponent2.default,
          inputComponentField: this.props.fields.application.additional_data.school_other,
          inputComponentProps: {
            type: 'text',
            onChangeHook: this.onChangeHook
          }
        }),
        (0, _commonFunctions.showPrimaryApplicantInfo)(this, dateRestrictions),
        (0, _commonFunctions.createAdditionalApplicantRows)(this, dateRestrictions),
        (0, _commonFunctions.showEligibilityBox)(this),
        (0, _commonFunctions.coverageTypeField)(this),
        (0, _commonFunctions.effectiveDateField)(this, dateRestrictions),
        _react2.default.createElement(_LabelledInputComponent2.default, {
          inputId: 'expiryDate',
          inputLabel: this.formConfig.expiry_date.title,
          inputComponent: _DatePickerComponent2.default,
          inputComponentField: this.props.fields.application.expiry_date,
          inputComponentProps: {
            placeholderText: (0, _translate.t)('Please select a date...'),
            showYearDropdown: true,
            showMonthDropdown: true,
            onChangeHook: function onChangeHook() {
              (0, _commonFunctions.changeExpiryAndCoverageLength)(_this2, 'expiry');_this2.onChangeHook();
            },
            minDate: dateRestrictions.application.expiry_date.min,
            maxDate: dateRestrictions.application.expiry_date.max,
            defaultDate: this.getDefaultExpiryDate(),
            disabled: true
          }
        }),
        (0, _commonFunctions.showCoverageLength)(this),
        (0, _commonFunctions.showSaveQuoteComponent)(this, _application2.default)
      );
    }
  }]);

  return GetQuoteComponent;
}(_react2.default.Component);

GetQuoteComponent.propTypes = _extends({}, _reduxForm.propTypes, {
  params: _react2.default.PropTypes.object,
  auth: _react2.default.PropTypes.object,
  application: _react2.default.PropTypes.object,
  formConfig: _react2.default.PropTypes.object,
  savedQuote: _react2.default.PropTypes.object,
  coverageType: _react2.default.PropTypes.string,
  trackingCode: _react2.default.PropTypes.string
});


var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.api.authorization,
    application: state.application,
    formConfig: state.formConfig.config,
    savedQuote: state.savedQuote.data
  };
};

exports.default = (0, _reduxForm.reduxForm)({
  form: 'genericis',
  fields: fields,
  destroyOnUnmount: false,
  touchOnBlur: false,
  validate: _Quote2.default
}, mapStateToProps)(GetQuoteComponent);


//////////////////
// WEBPACK FOOTER
// ./src/v2/containers/student_accident/GetQuoteContainer.jsx
// module id = 1715
// module chunks = 0